import request from "@/utils/request";

export function apigetWeixinLink(params){
    return request({
      url:'/auth/wechat/applet/app/api/getAppletsUrlToVehicleCargoOp',
      method:"GET",
	  params
    })
}